var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tablecell"},[_c('p',{style:({ color: _vm.textColor }),attrs:{"id":"risk-difference"}},[_vm._v("\n    "+_vm._s(_vm.renderRiskDifference)+"\n  ")]),_c('span',[_vm._v(_vm._s(_vm.pricifyTotalRisk))])])}
var staticRenderFns = []

export { render, staticRenderFns }